/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import gql from 'graphql-tag';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type OrdersInput = {
  readonly page: number;
  readonly take: number;
};

export type LastOrderDateQueryVariables = Exact<{
  input: Types.OrdersInput;
}>;

export type LastOrderDateQuery = {
  readonly orders:
    | {
        readonly __typename: 'OrdersResponseSuccess';
        readonly orders: ReadonlyArray<{
          readonly __typename: 'Order';
          readonly id: string;
          readonly wantedTime: string;
        }>;
      }
    | { readonly __typename: 'ValidationError' };
};

export const LastOrderDateDocument = gql`
  query LastOrderDate($input: OrdersInput!) {
    orders(input: $input) {
      __typename
      ... on OrdersResponseSuccess {
        orders {
          id
          __typename
          wantedTime
        }
      }
    }
  }
`;

export function useLastOrderDateQuery(
  options: Omit<Urql.UseQueryArgs<LastOrderDateQueryVariables>, 'query'>,
) {
  return Urql.useQuery<LastOrderDateQuery, LastOrderDateQueryVariables>({
    query: LastOrderDateDocument,
    ...options,
  });
}
